import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {RaisedButton, IconButton} from "material-ui";
import CreateIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import AddIcon from 'material-ui/svg-icons/content/add';

import StevedoringPopover from './StevedoringPopover';
import { changePort } from 'actions/regions/ports';

import AddServiceProvider from './AddServiceProvider';
import EditServiceProvider from './EditServiceProvider';

const styles = {
    btn: {
        style: { margin: '20px 0 70px 0' },
        labelStyle: { textTransform: 'none', fontSize: '13px' },
    }
};

class ServiceProvider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openEditDialog: false,
            openAddDialog: false,
            current: {
                field: '',
            },
        };

        this.toggleEditDialog = this.toggleEditDialog.bind(this);
        this.toggleAddDialog = this.toggleAddDialog.bind(this);
        this.addServiceProvider = this.addServiceProvider.bind(this);

    }

    addServiceProvider() {
        const { fields } = this.props;
        const emptyServiceProvider = {
            activities: [],
            name: undefined,
            address: undefined,
            PIC: undefined,
            emails: [undefined],
            phones: [{
                phone: undefined,
                code: undefined,
            }],
            limitations: [{
                maxDraught: undefined,
                maxBeam: undefined,
                maxLOA: undefined,
                maxDWT: undefined,
                channelDepth: undefined,
                anchorageDepth: undefined,
            }]
        };

        fields.push(emptyServiceProvider);
        this.toggleAddDialog({
            field: `${fields.name}[${fields.length}]`,
        });
    }

    toggleEditDialog(current = this.state.current) {
        this.setState({
            openEditDialog: !this.state.openEditDialog,
            current,
        });
    }

    toggleAddDialog(current = this.state.current) {
        this.setState({
            openAddDialog: !this.state.openAddDialog,
            current,
        });
    }

    render() {
        const { openEditDialog, openAddDialog, current } = this.state;
        const { fields, serviceProviders } = this.props;

        return (
            <Fragment>
                <div className="table">
                    <div className="table-header">
                        <div className="table-row">
                            <div className="table-col">
                                Activities
                            </div>
                            <div className="table-col">
                                Company Name
                            </div>
                            <div className="table-col">
                                Contact Details
                            </div>
                        </div>
                    </div>

                    <div className="table-body">
                        {
                            fields.map((field, index) => {

                                if (!serviceProviders[index]) {
                                    return;
                                }

                                return (<div className="table-row" key={index}>
                                    <div className="table-col info">
                                        <div className='name'>
                                            {
                                                serviceProviders[index].activities && serviceProviders[index].activities.includes('Stevedoring Company')
                                                    ?
                                                    <StevedoringPopover
                                                        serviceProvider={serviceProviders[index]}
                                                    />
                                                    :
                                                    <div>
                                                        {
                                                            serviceProviders[index].activities.map((activity, index) => {
                                                                return (
                                                                    <div key={`activity_${index}`}>
                                                                        <span key={`activity_${index}`}>{activity}</span><br/>
                                                                    </div>
                                                                );
                                                            })
                                                        }
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="table-col">
                                        <div className='name company'>
                                            {serviceProviders[index].name}
                                        </div>
                                    </div>
                                    <div className="table-col">
                                        <div className="list">
                                            {
                                                serviceProviders[index].emails.map((email, emailIndex) => {
                                                    return (<div key={emailIndex} className='email'>{email}</div>)
                                                })
                                            }
                                        </div>

                                        <div className="list">
                                            {
                                                serviceProviders[index].phones.map((phone, phoneIndex) => {
                                                    return (<div key={phoneIndex} className='phone'>{`${phone.code} ${phone.phone}` }</div>)
                                                })
                                            }
                                        </div>

                                        <div className='name'>
                                            {serviceProviders[index].address}
                                        </div>

                                        <div className='name'>
                                            PIC: {serviceProviders[index].PIC}
                                        </div>
                                    </div>
                                    <div className="table-col edit">
                                        <div className="icon edit-icon">
                                            <IconButton
                                                iconStyle={{ color: '#CBCBCB' }}
                                                onClick={() => {
                                                    this.toggleEditDialog({ field })
                                                }}>
                                                <CreateIcon />
                                            </IconButton>
                                        </div>

                                        <div className="icon delete-icon">
                                            <IconButton
                                                iconStyle={{  color: '#CBCBCB' }}
                                                onClick={() => {
                                                    fields.remove(index);
                                                }}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>);
                            })
                        }
                    </div>
                </div>

                <RaisedButton
                    label={'Add Service Provider'}
                    labelStyle={styles.btn.labelStyle}
                    style={styles.btn.style}
                    labelPosition="before"
                    icon={<AddIcon />}
                    primary
                    onClick={this.addServiceProvider}
                />

                <EditServiceProvider
                    open={openEditDialog}
                    toggle={this.toggleEditDialog}
                    field={current.field}
                />

                <AddServiceProvider
                    open={openAddDialog}
                    toggle={this.toggleAddDialog}
                    field={current.field}
                    fields={fields}
                />
            </Fragment>
        );
    }
}

ServiceProvider.propTypes = {
    port: PropTypes.object,
};

ServiceProvider.defaultProps = {
    port: {},
};

export default connect(
    (state, ownProps) => {
        return {
            ...ownProps,
            serviceProviders: { ...state.port.serviceProviders, },
        };
    },
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(ServiceProvider);


// WEBPACK FOOTER //
// ./app/components/Regions/Port/ServiceProviders/ServiceProvider.jsx